import { DEFAULT_SIDEBAR_TAB_TYPE, type SidebarTemplateTagTab } from './sidebar';

interface LastSidebarSelection {
  selectedTabType: string;
  selectedTemplateTag: SidebarTemplateTagTab['templateTag'] | null;
  selectedChannelBranch: SidebarTemplateTagTab['channelBranch'];
}

const DEFAULT_SELECTION: LastSidebarSelection = {
  selectedTabType: DEFAULT_SIDEBAR_TAB_TYPE,
  selectedTemplateTag: null,
  selectedChannelBranch: null,
};

/**
 * Where the gallery was left, so reopening it resumes the browsing rather than restarting it. Held
 * for the life of the tab and deliberately not persisted: a session later, "where I was" is a
 * guess, and the default is the better one.
 */
let lastSelection: LastSidebarSelection | null = null;

export const getLastSidebarSelection = (): LastSidebarSelection =>
  lastSelection || DEFAULT_SELECTION;

/** Whether there is anything to resume, which is what lets a caller name a tab only as a fallback. */
export const hasLastSidebarSelection = (): boolean => lastSelection !== null;

export const rememberSidebarSelection = (selection: LastSidebarSelection): void => {
  lastSelection = selection;
};
